import { render, staticRenderFns } from "./SpcmMilestonesEdit.vue?vue&type=template&id=0b9f3716&scoped=true"
import script from "./SpcmMilestonesEdit.vue?vue&type=script&lang=js"
export * from "./SpcmMilestonesEdit.vue?vue&type=script&lang=js"
import style0 from "./SpcmMilestonesEdit.vue?vue&type=style&index=0&id=0b9f3716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f3716",
  null
  
)

export default component.exports